module.exports = __webpack_public_path__ + "media/components/participants_components/static/Path-d99f49d2b7ccc67eadeffc64d1731ca8.png";